/* global SingleMvpd */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { forceHttps, isMvpdSubscription } from 'helpers/ContentHelper';
import { isPreviewPass } from 'helpers/PlayerHelper';
import HeaderLink from '../HeaderLink';
import style from './ProviderLogo.module.scss';

const disableAuthentication = () => {
  const { disableAuthentication = false } = window.ExternalConfig;

  return disableAuthentication;
};

const ProviderLogo = ({
  isSearchActive,
  onLogoutClick,
  provider,
  providerSet,
  renderPreviewPass,
  setTriggerAuthCheck,
  toggleMvpdAuthOverlay,
}) => {
  if (SingleMvpd || disableAuthentication()) return null;

  const { profileLogout_logoutButton: signoutLabel } = window.Language;
  const mvpd = _.get(provider, 'adobePassId');
  const hasProvider = !!provider;

  if (!hasProvider || isSearchActive || (isPreviewPass(mvpd) && !renderPreviewPass)) {
    return null;
  }

  const secondaryLogo = _.get(provider, 'logos[0].url');
  const providerLogo = forceHttps(_.get(provider, 'logos[1].url', secondaryLogo));
  const providerClasses = classNames(
    style.rightIcon,
    style.providerLogo,
    style.providerLogoDesktop,
  );
  const signOutButton = () => {
    if (isPreviewPass(mvpd) || isMvpdSubscription()) return null;
    return (
      <div className={style.signOutContainer}>
        <button
          className={style.signOutButton}
          onClick={e => {
            onLogoutClick(e);
          }}
        >
          {signoutLabel}
        </button>
      </div>
    );
  };

  if (!providerLogo || !providerSet) return null;
  let image = <img src={providerLogo} alt={_.get(provider, 'name', 'Cable Provider Logo')} />;
  if (provider.siteUrl) {
    image = HeaderLink({ to: provider.siteUrl, target: '_self' }, image);
  }
  return (
    <div className={providerClasses}>
      {image}
      {signOutButton()}
    </div>
  );
};

export default ProviderLogo;

ProviderLogo.propTypes = {
  isSearchActive: PropTypes.bool.isRequired,
  onLogoutClick: PropTypes.func.isRequired,
  provider: PropTypes.shape({
    logos: PropTypes.array,
  }),
  providerSet: PropTypes.bool.isRequired,
  renderPreviewPass: PropTypes.bool.isRequired,
  setTriggerAuthCheck: PropTypes.func.isRequired,
  toggleMvpdAuthOverlay: PropTypes.func.isRequired,
};
